var map = {
	"./add-way-1.png": "b0f8",
	"./add-way-2.png": "d446",
	"./add-way-3.png": "872d",
	"./audio.png": "0361",
	"./avatars/1-small.png": "28a5",
	"./avatars/1.png": "f7d6",
	"./avatars/10-small.png": "ceac",
	"./avatars/10.png": "e929",
	"./avatars/11-small.png": "b922",
	"./avatars/11.png": "2b14",
	"./avatars/12-small.png": "5e8f",
	"./avatars/12.png": "3fb4",
	"./avatars/13-small.png": "977a",
	"./avatars/13.png": "dbcc",
	"./avatars/2-small.png": "f548",
	"./avatars/2.png": "3e88",
	"./avatars/3-small.png": "a921",
	"./avatars/3.png": "e251",
	"./avatars/4-small.png": "103d",
	"./avatars/4.png": "5235",
	"./avatars/5-small.png": "da2a",
	"./avatars/5.png": "7df9",
	"./avatars/6-small.png": "73bb",
	"./avatars/6.png": "045e",
	"./avatars/7-small.png": "af6d",
	"./avatars/7.png": "c7c0",
	"./avatars/8-small.png": "09d5",
	"./avatars/8.png": "2825",
	"./avatars/9-small.png": "f8f8",
	"./avatars/9.png": "2305",
	"./avatars/avatar.png": "4dab",
	"./avatars/avatar2.png": "c055",
	"./diamond.png": "e04c",
	"./document.png": "3142",
	"./error.png": "fa93",
	"./excel.png": "6a56",
	"./file.png": "87d4",
	"./flags/de.png": "72fe",
	"./flags/en.png": "9996",
	"./flags/fr.png": "26fc",
	"./flags/pt.png": "5e3c",
	"./google-contacts.png": "a3c4",
	"./icons/apple-safari.png": "4f49",
	"./icons/doc.png": "493f",
	"./icons/drive.png": "8f4a",
	"./icons/dropbox.png": "0e4f",
	"./icons/file-icons/doc.png": "61d5",
	"./icons/file-icons/onedrive.png": "37bc",
	"./icons/file-icons/pdf.png": "a235",
	"./icons/file-icons/psd.png": "051b",
	"./icons/file-icons/sketch.png": "2863",
	"./icons/google-chrome.png": "d8dc",
	"./icons/icloud-1.png": "e4ab",
	"./icons/icloud.png": "9431",
	"./icons/internet-explorer.png": "d7bc",
	"./icons/internet.png": "beef",
	"./icons/jpg.png": "1568",
	"./icons/js.png": "2710",
	"./icons/json.png": "0ec4",
	"./icons/mozila-firefox.png": "9fa4",
	"./icons/onedrive.png": "8250",
	"./icons/onedrivenew.png": "efb5",
	"./icons/opera.png": "2fad",
	"./icons/pdf.png": "f35f",
	"./icons/psd.png": "3a95",
	"./icons/sketch.png": "c62d",
	"./icons/txt.png": "d36d",
	"./icons/unknown.png": "91ed",
	"./icons/xls.png": "d75a",
	"./image.png": "bf05",
	"./logo/logo.png": "a4ef",
	"./logo/vuexy-logo.png": "d120",
	"./meta.png": "4bf5",
	"./notice.png": "5114",
	"./octo.png": "f33d",
	"./pages/arrow-down.png": "ba74",
	"./pages/auth-v1-bottom-bg.png": "cc4f",
	"./pages/auth-v1-top-bg.png": "06c1",
	"./pages/calendar-illustration.png": "8c71",
	"./pages/forgot-password.png": "95e0",
	"./pages/pixinvent-logo.png": "0ec0",
	"./pdf.png": "b9de",
	"./phone.png": "1e37",
	"./plan_1.png": "1bda",
	"./plan_2.png": "c66d",
	"./plan_3.png": "66dc",
	"./ppt.png": "fe3e",
	"./rocket.png": "8cbf",
	"./sad.png": "0aa2",
	"./slow_mode.png": "777c",
	"./superhero.png": "6afb",
	"./tahdir.png": "fe6e",
	"./upload.png": "894f",
	"./user-error.png": "9a99",
	"./video.png": "c59e",
	"./warning.png": "e57e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";